import SqFetch from 'typescript/application/sq_fetch';
import { _handleResponse } from 'typescript/clients/utilities/handle_http_response';
import { CountryCode, LanguageCode } from 'typescript/constants/localization';
import { ListOffersResponse } from 'typescript/types/api/offers';
import { _urlContext } from 'typescript/clients/utilities/common';

// functions are controlled by the methods in this controller
// app/controllers/sq/api/checkout/offers_controller.rb

export const LIST_OFFERS_BASE_URL = '/shop/api/v1/checkout/offers/list';
export const SELECT_OFFER_URL = '/shop/api/v1/checkout/offers/select';

/**
 * List offers
 * @returns installment offers for the current order
 */
export const listOffers = async ({
  orderNumber,
  countryCode,
  languageCode,
}: {
  orderNumber: string;
  countryCode: CountryCode;
  languageCode: LanguageCode;
}): Promise<ListOffersResponse> => {
  const response = await SqFetch.get(
    `${LIST_OFFERS_BASE_URL}${_urlContext({
      countryCode,
      languageCode,
      orderNumber,
    })}`,
  );

  return _handleResponse(response);
};

/**
 * Select an installment offer.
 * @returns success or error message
 */
export const selectOffer = async ({
  languageCode,
  orderNumber,
  selectedOfferToken,
  countryCode,
}: {
  languageCode: LanguageCode;
  orderNumber: string;
  selectedOfferToken: string;
  countryCode: CountryCode;
}): Promise<{ success: boolean }> => {
  const response = await SqFetch.post(SELECT_OFFER_URL, {
    language_code: languageCode,
    order_number: orderNumber,
    selected_offer_token: selectedOfferToken,
    store_code: countryCode,
  });

  return _handleResponse(response);
};
